import { useMemo } from 'react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import usePaginatedQuery from '@/hooks/usePaginatedQuery'

export type QueryVariables = {
  filter: GraphQL.QueryGuestFilter
  sort: GraphQL.QueryGuestSort
}

export default function usePaginatedGuests(variables: QueryVariables) {
  const { items: fragmentItems, ...rest } = usePaginatedQuery(
    AdminAPI.guest.QUERY,
    variables,
    {
      document: AdminAPI.guest.CHANGED,
      typename: 'Guest'
    }
  )

  const items = useMemo(() => {
    return fragmentItems?.map(item =>
      getFragment(SharedAPI.guest.GUEST_FRAGMENT, item)
    )
  }, [fragmentItems])

  return {
    items,
    ...rest
  }
}
